import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export const userProfileDefaultValue = {
  handle: "",
  name: "",
  email: "",
  phoneNumber: "",
  birthday: "",
  gender: "",
  avatar: "",
  itemsCount: 0,
  wishlistCount: 0,
  requestedToFollow: null,
  followStatus: null,
  followingCount: 0,
  followerCount: 0,
  isPremium: false,
  isCloseFriend: false
}

const initialState = {
  profile: null,
  isAuthenticated: false,
  wishListsWithFirstFourItems: null,
  wishLists: null,
  wishItems: null,
  followRequests: [],
  closeFriends: []
} as LoggedInUserProfileInfo

export const user = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    updateUserIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
    updateUserProfile: (state, action: PayloadAction<Profile | null>) => {
      state.profile = action.payload || null
    },
    updateUserWishListsWithFirstFourItems: (state, action: PayloadAction<GetWishListsResponseDto>) => {
      state.wishListsWithFirstFourItems = structuredClone(action.payload.wishlists)
    },
    updateUserWishLists: (state, action: PayloadAction<GetWishListsResponseDto>) => {
      state.wishLists = structuredClone(action.payload.wishlists)
    },
    updateUserWishItems: (state, action: PayloadAction<GetWishItemsResponseDto>) => {
      state.wishItems = action.payload.items
    },
    updateFollowRequests: (state, action: PayloadAction<FollowRequest[]>) => {
      state.followRequests = action.payload ? structuredClone(action.payload) : []
    },
    updateCloseFriends: (state, action: PayloadAction<UserDto[]>) => {
      state.closeFriends = action.payload ? structuredClone(action.payload) : []
    },
    resetUserProfileSlice: () => structuredClone(initialState)
  }
})

export const {
  updateUserIsAuthenticated,
  updateUserProfile,
  updateUserWishListsWithFirstFourItems,
  updateUserWishLists,
  updateUserWishItems,
  updateFollowRequests,
  updateCloseFriends,
  resetUserProfileSlice
} = user.actions

export default user.reducer
